import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, DropdownMenu, DropdownMenuItem } from 'seagull';
import { ChevronDown, Download, Import } from 'seagull/icons';
import { Intent } from '~/infra/access-control';
export const DraftsMoreActionsMenu = (param)=>{
    let { testIds, texts, hasDrafts, exportingAllCsv, onImport, onExportAll } = param;
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        testId: testIds.Menu(),
        target: /*#__PURE__*/ _jsx(Button, {
            bi: {
                name: 'open_drafts_more_actions'
            },
            skin: "primaryOutline",
            testId: testIds.Button(),
            suffixIcon: /*#__PURE__*/ _jsx(ChevronDown, {}),
            children: texts.moreActions()
        }),
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuItem, {
                testId: testIds.Import(),
                iconStart: /*#__PURE__*/ _jsx(Download, {}),
                bi: {
                    name: 'import_drafts'
                },
                onClick: onImport,
                children: texts.importButton()
            }),
            hasDrafts && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                testId: testIds.ExportAll(),
                iconStart: /*#__PURE__*/ _jsx(Import, {}),
                bi: {
                    name: 'export_drafts'
                },
                onClick: onExportAll,
                disabled: exportingAllCsv,
                intent: Intent.ExportDraftsToCsv,
                children: texts.exportAll()
            })
        ]
    });
};
